import React, { Component } from 'react';
import classes from './feedback.module.css';
import {Modal, Row, Col, Table} from 'react-bootstrap';
import {connect} from 'react-redux';
import * as actionTypes from '../../Action/Index';
import Loader from 'react-loader-advanced';
import Spinner from 'react-bootstrap/Spinner';
import SweetAlert from '../commonComponents/SweetAlert';
import moment from 'moment';

class feedback extends Component {

    state = {
        feedBackErr: false
    }

    actionDispatchHandler = () => {
        this.props.getCandidateFeedback(this.props.id)
    }


    componentWillReceiveProps(nextProps){
        if(this.state.feedBackErr !== nextProps.feedBackErr){
            this.setState({
                feedBackErr: nextProps.feedBackErr
            })
        }
    }
   
    render() {
        let keys ="";
        let values = null;
        let obj=this.props.skillRating;
       
        let keyArray = Object.keys(obj).map((index)=>
        {
            return  <Col md={6} className={classes.SkillsCol}>
            <Row>
           <Col md={9}> <span style={{ textTransform: 'capitalize' }}>{index}</span></Col>
           <Col md={3}> <span>{obj[index]>0? obj[index] : obj[index]==0?"NS":"NE"}</span></Col>
          </Row>
          <br/>
        </Col>
        })

        const months = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let current_datetime = new Date(this.props.candidateFeedback.interviewDate/1000)
        let formatted_date = current_datetime.getDate() + " " + months[current_datetime.getMonth()]
            
        let timeobject = new Date(this.props.candidateFeedback.startTime/1000);
        let hourstart = moment(timeobject).utc().format('hh:mm A')
        let timeobject2 = new Date(this.props.candidateFeedback.endTime/1000);
         let hourend = moment(timeobject2).utc().format('hh:mm A')
         
    
     return (
            <>
            {!this.props.feedBackErr ? 
            <Modal {...this.props} id="Dialogid" show={this.props.show} onHide={this.props.handleClose} backdrop="false" size="lg" centered={true}
                   onShow = {() => {this.actionDispatchHandler()}} >
              
              <Modal.Body>
              <Loader show={this.props.loader} message={ <Spinner animation="border" role="status"></Spinner> }
            foregroundStyle={{color: '#fbb03b'}}
            backgroundStyle={{backgroundColor: 'white'}}
            >
                  <div className={classes.modalBody}>
              <div className={classes.modalClose} onClick={this.props.handleClose}> <i className={`fa fa-times-circle`}> </i> </div>
              <div className={classes.heading}><h4>Feedback</h4></div>
                <Row>
                    <Col md={8}>
                        <span className={classes.details}>{this.props.candidateFeedback.candidateName}</span>
                        {/* <span className={classes.details}>{this.props.candidateFeedback.candidateExperienceInYears}&nbsp;{this.props.candidateFeedback.candidateExperienceInYears > 1 ? 'years' : 'year'} {this.props.candidateFeedback.candidateExperienceInMonths}&nbsp;{this.props.candidateFeedback.candidateExperienceInMonths > 1 ? 'months' : 'month'}</span> */}
                        <span className={classes.details}>{this.props.candidateFeedback.jobProfile !== undefined ?this.props.candidateFeedback.jobProfile: null}</span>       
                        {/* <span className={classes.details}>Assessed By: &nbsp; <span style = {{textTransform: "capitalize"}}>{this.props.candidateFeedback.interviewerName}</span></span> */}
                        <span className={classes.details}>Date of Interview: &nbsp; <span>{formatted_date}, {hourstart}-{hourend}</span></span>
                    </Col>
                    <Col md={4}>
                        <div className={classes.right}>
                        <span className={classes.shortlist}>
                        {this.props.interviewFeedback.overallRecommendation=="On_Hold"?
                             <h4 style={{color:"orange"}}>
                             {this.props.interviewFeedback.overallRecommendation}
                             </h4>:null
                        }
                            { this.props.interviewFeedback.overallRecommendation=="Rejected"?
                             <h4 style={{color:"red"}}>
                             {this.props.interviewFeedback.overallRecommendation}
                             </h4>
                            :null}
                            { this.props.interviewFeedback.overallRecommendation=="Shortlisted"?
                            <h4>
                             {this.props.interviewFeedback.overallRecommendation}
                             </h4>:null
                            }
                           {this.props.interviewFeedback.overallRecommendation == "Did_Not_Happen" ?
                                    <h4 style={{ color: "orange" }}>
                                        Did not happen
                                    </h4> : null
                                }
                        </span>
                        
                        {/* <span className={classes.profile}><h5 style = {{fontSize: '19px'}}>{this.props.candidateFeedback.jobProfile !== undefined ? this.props.candidateFeedback.jobProfile.toLowerCase(): null}</h5></span> */}
                        </div>
                    </Col>
                </Row>
                <br/>
                <Row>
                    <Col md={12}>
                    <span className={`${classes.details} ${classes.marginbottom}`}>Skills ( Scaled between 1 to 10, 10 being the highest ): </span>
                    </Col>
                </Row>
                <Table striped bordered hover borderless className={classes.feedbackTable}>
                    <Row style = {{padding: '18px'}}>
                   {keyArray}
                    </Row>
                </Table>
                <Row>
                     <Col md={3}><span className={classes.details}>Overall feedback:</span></Col>
                     <Col md={9}>
                         <Row>
                             <Col md={12}><span className={classes.details} style={{marginLeft: "-52px"}}>{this.props.interviewFeedback.overAllFeedback}</span></Col>

                         </Row>
                     </Col>
                </Row>
                <br/>
                <Row>
                    <Col>
                   <span>
                   <span style={{color:"red"}}>*</span> NS - Candidate does not have skill<br/>
                   <span style={{color:"red"}}>*</span> NE - Skill not evaluated by interviewer
                   </span>
                   </Col> 
                   </Row>
                </div>
                </Loader>
              </Modal.Body> 
              
            </Modal> : null}
             {this.state.feedBackErr? <SweetAlert type = "danger" show="true" msg = "Failed to load data"/>:null}
          </>
        );
    }
}

const mapStateToProps = state => {
    return{
        loader: state.employeeReducer.feedbackLoader,
        candidateFeedback: state.employeeReducer.candidateFeedback,
        interviewFeedback: state.employeeReducer.interviewFeedback,
        skillRating: state.employeeReducer.skillRating,
        feedBackErr: state.employeeReducer.feedBackErr
    }
}

const mapDispatchToProps = dispatch => {
    return{
        getCandidateFeedback: (id) => dispatch(actionTypes.getCandidateFeedback(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(feedback);